export const CHARS_LIMIT = 1000;
export const FORM_MESSAGE_BOX_HEIGHT = 20;
